import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const phase_created = ({ event: { kind } }) =>
  <div className={kind}>
    Phase Created
  </div>;

phase_created.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({}).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/phase_created.jsx